import script from "./OverseaProductSku.vue?vue&type=script&lang=ts&setup=true"
export * from "./OverseaProductSku.vue?vue&type=script&lang=ts&setup=true"

import "./OverseaProductSku.vue?vue&type=style&index=0&id=b3afffb8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3afffb8"]])

export default __exports__